//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'


//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.non_native_ebook_highlights;
//  -- Examples array selector --------

export const useNonNativeEbookHighlightes = () => {
    const selectedData = useSelector(selectore, shallowEqual)
   return selectedData;
}
